module.exports = __webpack_public_path__ + "img/bn.d140e17.svg";